
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Gallery } from "@/components/Gallery";

const GalleryPage = () => {
  return (
    <div className="min-h-screen" dir="rtl">
      <Navbar />
      <div className="pt-16 md:pt-20">
        <Gallery />
      </div>
      <Footer />
    </div>
  );
};

export default GalleryPage;
